import { render, staticRenderFns } from "./DwEnrollmentsByMonth.vue?vue&type=template&id=52c89d73&"
import script from "./DwEnrollmentsByMonth.vue?vue&type=script&lang=js&"
export * from "./DwEnrollmentsByMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports